import { createFileRoute, redirect } from "@tanstack/react-router";
import { UploadForm, MyUploadsList } from "@/components/upload";

interface UploadSearch {
  just_uploaded?: string;
}

export const Route = createFileRoute("/upload")({
  validateSearch: (search: Record<string, unknown>): UploadSearch => ({
    just_uploaded:
      typeof search.just_uploaded === "string" ? search.just_uploaded : undefined,
  }),
  // Require auth + organization membership (spec §6.1). The "Contributed"
  // option inside the form is gated separately by role; the server is
  // authoritative regardless. isLoading guard avoids redirecting during the
  // AuthProvider's initial bootstrap.
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) return;
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: "/login", search: { redirect: "/upload" } });
    }
    if (!context.auth.user?.org_id) {
      // Authenticated but unaffiliated (incl. admins without an org, who use
      // the legacy /ingest path for Commons ingestion).
      throw redirect({ to: "/" });
    }
  },
  component: UploadPage,
});

function UploadPage() {
  const { just_uploaded } = Route.useSearch();
  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-10">
      <h1 className="font-serif text-section text-ink-primary">Upload a document</h1>
      <p className="mt-1 text-meta text-ink-secondary">
        Add a PDF to your organization’s collection, or contribute it to the public Commons.
      </p>

      <div className="mt-6">
        <UploadForm />
      </div>

      <section className="mt-10">
        <h2 className="text-caps uppercase tracking-caps text-ink-tertiary">Recent uploads</h2>
        <div className="mt-3">
          <MyUploadsList highlightId={just_uploaded} />
        </div>
      </section>
    </div>
  );
}
